import React from 'react'
import { cancellationMessageParts } from '../../../texts/cancellation'

// One message cell: for the coded Tranzila-unavailable entry the approved sentence first, then the complete stored
// message underneath (line breaks preserved). Plain text nodes only, never raw HTML.
const MessageContent = ({ entry }: { entry: any }) => {
    const { lead, body } = cancellationMessageParts(entry)
    return (
        <div style={{ maxWidth: '250px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {lead && <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>{lead}</div>}
            <div>{body}</div>
        </div>
    )
}

export default MessageContent
